import { GET_ALL_SYSTEM_LOGS } from '../types';

const initialState = {
  systemLogs: [],
};

export default function SystemLog(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_SYSTEM_LOGS:
      return {
        ...state,
        systemLogs: action.payload,
      };
    default:
      return state;
  }
}
